export default "__VITE_ASSET__Bg7eY2G7__"